<template>
  <div class="pay-search">
    <div class="hd ly-card">
      <div class="fl">
        <advanced-query @search="search" size="medium" />
        <!-- <el-button type="primary" size="medium" @click.native="dialogVisible = true" :disabled="!selection.length">批量补费</el-button> -->
      </div>
      <div class="fr">
        <el-select
          class="m-r-10"
          v-model="is_apply_refund"
          placeholder="退款申请状态"
        >
          <el-option :key="0" label="全部" :value="0"></el-option>
          <el-option :key="1" label="已申请" :value="1"></el-option>
          <el-option :key="3" label="未申请" :value="3"></el-option>
        </el-select>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-input placeholder="姓名/证件号/预约号/班级" v-model.trim="query"></el-input>
        <el-button @click="() => search()">查询</el-button>
        <el-button type="primary" size="medium" @click.native="exportExcel">导出</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :tableConfig="tableConfig"
      class="ly-card"
      ref="lyTable"
      @dataChange='getTotal'
    >
      <template v-slot:real_fee="row">{{ row.real_fee }}/{{ row.refund_fee || 0 }}</template>
      <template v-slot:reservation_number="row">
        <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{
          row.reservation_number
        }}</el-button>
      </template>
      <template v-slot:sign_up_fee_real_fee="row">
        {{ row.sign_up_fee }}/{{ row.real_fee }}
      </template>
      <template v-slot:audit_refund_fee="row">
        <el-button v-if="row.audit_refund_fee" type="text" size="small" @click="() => openDrawer(row, 'audit_refund_fee')">{{row.audit_refund_fee}}</el-button>
        <span v-else>{{row.audit_refund_fee}}</span>
      </template>
      <template v-slot:audit_supply_fee="row">
        <el-button v-if="row.audit_supply_fee" type="text" size="small" @click="() => openDrawer(row, 'audit_supply_fee')">{{row.audit_supply_fee}}</el-button>
        <span v-else>{{row.audit_supply_fee}}</span>
      </template>
      <template v-slot:already_supply_fee_refund_fee="row">
        <el-button v-if="row.already_supply_fee" type="text" size="small" @click="() => openDrawer(row, 'already_supply_fee')">{{row.already_supply_fee}}</el-button>
        <span v-else>{{row.already_supply_fee}}</span>
        <span> / </span>
        <el-button v-if="row.refund_fee" type="text" size="small" @click="() => openDrawer(row, 'refund_fee')">{{row.refund_fee}}</el-button>
        <span v-else>{{row.refund_fee}}</span>
      </template>
      <template v-slot:action="row">
        <el-button @click="openRs(row)" type="text" size="mini" v-if="row.refund_user_info.order_number">查看</el-button>
        <span v-else>无</span>
      </template>
    </ly-table>
    <pay-detail
      ref="payDetail"
      :sign_up_id="defData.id"
      :def="defData"
      :class_id="defData.class_id"
      :contact_id="defData.contact_id"
      :keep_reserved="defData.keep_reserved"
      :buttons="buttons"
      @success="search"
    />
    <el-drawer
      :title="drawer[drawer.key].title"
      :visible.sync="drawer.visible"
      size="600px"
      :direction="drawer.direction">
      <ly-table
        :getTableData="drawer[drawer.key].getTableData"
        :tableHeader="drawer[drawer.key].tableHeader"
        :searchFormData="drawer.searchFormData"
        ref="drawerTable"
      ></ly-table>
    </el-drawer>
    <el-dialog title="批量补费申请" append-to-body :visible.sync="dialogVisible" width="600px" v-loading="loading">
      <div class="batch-body">
        <table class="native-table">
        <tr>
          <th>收费项目</th>
          <th>补费</th>
        </tr>
        <tr>
          <td>学费</td>
          <td>
            <el-input v-model="form.class_fee" placeholder="学费"></el-input>
          </td>
        </tr>
        <tr>
          <td>保险费</td>
          <td>
            <el-input v-model="form.insurance" placeholder="保险费"></el-input>
          </td>
        </tr>
        <tr>
          <td>伙食费</td>
          <td>
            <el-input v-model="form.food_expenses" placeholder="伙食费"></el-input>
          </td>
        </tr>
        <tr>
          <td>材料费</td>
          <td>
            <el-input v-model="form.material_fee" placeholder="材料费"></el-input>
          </td>
        </tr>
          <tr>
            <td>食宿交通门票等</td>
            <td>
              <el-input v-model="form.accommodation_traffic_ticket" placeholder="食宿交通门票等"></el-input>
            </td>
          </tr>
<!--        <tr>
          <td>托管费</td>
          <td>
            <el-input v-model="form.hosting_fee" placeholder="托管费"></el-input>
          </td>
        </tr>
        <tr>
          <td>陪读费</td>
          <td>
            <el-input v-model="form.accompanying_fee" placeholder="陪读费"></el-input>
          </td>
        </tr>-->
        </table>
        <div class="m-t-10 m-b-10">
          <div class="p-b-10">补费原因：</div>
          <el-input type="textarea" placeholder="请填写原因" v-model="supply_reason"></el-input>
        </div>
        <div style="font-size: 16px"><strong>总额：<span style="color: red">{{total_fee}} （元）</span></strong></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchSupplyFee">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退款申请信息"
      :visible.sync="refundInfoVisble"
      width="600px"
      class="register-contact-form refund-dialog"
    >
      <table  class="native-table">
        <template v-if="refundInfo.pay_type===3">
          <tr>
            <td class='natable-left'>户主姓名</td>
            <td class='natable-right'>{{refundInfo.householder_name}}</td>
          </tr>
          <tr>
            <td class='natable-left'>开户行</td>
            <td class='natable-right'>{{refundInfo.account_bank_label}}</td>
          </tr>
          <tr>
            <td class='natable-left'>卡号</td>
            <td class='natable-right'>{{refundInfo.bank_card_number}}</td>
          </tr>
        </template>
        <tr>
          <td class='natable-left'>应退课次</td>
          <td class='natable-right'>{{refundInfo.actual_refund_course}}</td>
        </tr>
        <tr>
          <td class='natable-left'>退款原因</td>
          <td class='natable-right'>{{refundInfo.refund_reason}}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import { DatePicker, Drawer, Input, Dialog, Select, Option } from 'element-ui';
import LyTable from '@/components/LyTable';
import { financePayTable, applyTableDrawer, refundTableDrawer } from '@/utils/tableHeader';
import { specializedSearchForm } from '@/utils/formConfigCommon';
import PayDetail from '@/components/PayDetail';
import { finance, logger } from '@/api';
import AdvancedQuery from '@/components/AdvancedQuery';
import utils from '@/utils/utils';
import pattern from '@/utils/pattern';

const Decimal = require('decimal.js');

export default {
  name: 'PaySearch',
  components: {
    LyTable,
    ElDatePicker: DatePicker,
    ElInput: Input,
    PayDetail,
    AdvancedQuery,
    ElDrawer: Drawer,
    ElDialog: Dialog,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      total: 0,
      loading: false,
      supply_reason: '',
      form: {
        class_fee: '',
        material_fee: '',
        insurance: '',
        food_expenses: '',
        accompanying_fee: '',
        hosting_fee: ''
      },
      selection: [],
      dialogVisible: false,
      refundInfoVisble: false,
      refundInfo: {},
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      drawer: {
        visible: false,
        direction: 'rtl',
        key: 'already_supply_fee',
        searchFormData: {
          is_apply_refund: ''
        },
        already_supply_fee: {
          title: '已补详情',
          tableHeader: applyTableDrawer,
          getTableData: finance.alreadySupply
        },
        refund_fee: {
          title: '已退详情',
          tableHeader: refundTableDrawer,
          getTableData: finance.alreadyRefund
        },
        audit_refund_fee: {
          title: '退款中详情',
          tableHeader: refundTableDrawer,
          getTableData: finance.auditRefund
        },
        audit_supply_fee: {
          title: '补费中详情',
          tableHeader: applyTableDrawer,
          getTableData: finance.auditSupplyFee
        }
      },
      date: '',
      searchFormData: {},
      tempSearch: {},
      query: '',
      is_apply_refund: 0,
      tableHeader: [],
      getTableData: finance.paymentQuery,
      searchFormConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormKeys: specializedSearchForm,
      defData: {
        class_id: 0,
        contact_id: 0,
        id: 0,
        keep_reserved: '是'
      },
      payType: [],
      buttons: [1, 2, 3] // 退费补费页面显示的按钮
    };
  },
  mounted() {
    this.search();
    finance.getPayType().then(res => {
      if (res) {
        financePayTable[financePayTable.length - 2].headerSlot.select = res.data;
        financePayTable[financePayTable.length - 3].headerSlot.select = [
          {
            label: '已缴费',
            value: 4
          },
          {
            label: '已申请退款',
            value: 7
          },
          {
            label: '已退费',
            value: 8
          },
          {
            label: '已拒绝',
            value: 9
          },
          {
            label: '后台退款',
            value: 15
          },
          {
            label: '银联退款中',
            value: 16
          }
        ];
        this.tableHeader = financePayTable;
      }
    });
  },
  computed: {
    total_fee() {
      let total_fee = 0;
      Object.keys(this.form).every(key => {
        const value = this.form[key];
        if (value && pattern.decimal.test(value)) {
          total_fee = Decimal.add(total_fee, value).toNumber();
          return true;
        }
        if (value && !pattern.decimal.test(value)) return false;
        return true;
      });
      return total_fee;
    },
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    }
  },
  methods: {
    getTotal({ total }) {
      this.total = total;
    },
    exportExcel() {
      const params = { sign_up_status: this.$store.sign_up_status, pay_type: this.$store.pay_type, ...this.searchFormData };
      if (params.year === -1) {
        delete params.year;
      }
      if (params.term === -1) {
        delete params.term;
      }
      finance
        .exportPayment({
          params
        })
        .then(data => {
          if (data) {
            logger.fetchLoggerPost({
              module: 2,
              event_type: 6,
              cusp: `批量导出缴费信息数据“${this.total}”条`,
              status: 1
            });
            utils.downloadData(data, '缴费列表');
          }
        });
    },
    search(data) {
      if (data) {
        this.tempSearch = data;
      }
      const temp = !data || data.type ? {} : data;
      let pay_start_time;
      let pay_end_time;
      if (this.date && this.date.length) {
        [pay_start_time, pay_end_time] = this.date;
        temp.pay_start_time = pay_start_time;
        temp.pay_end_time = pay_end_time;
      }
      this.searchFormData = {
        ...this.tempSearch,
        query: this.query,
        ...temp
      };
      if (this.is_apply_refund) {
        if (this.is_apply_refund === 3) {
          this.searchFormData = {
            is_apply_refund: 0,
            ...this.searchFormData
          };
        }
        this.searchFormData = {
          is_apply_refund: this.is_apply_refund,
          ...this.searchFormData
        };
      }
      this.$refs.lyTable.setData();
    },
    openInf(row) {
      this.defData = { ...row };
      const params = {
        module: 2,
        event_type: 3,
        cusp: `查看预约号“${row.reservation_number}”的缴费详情`,
        status: 1
      };
      logger.fetchLoggerPost(params);
      this.$refs.payDetail.open();
    },
    openDrawer(row, key) {
      this.drawer.visible = true;
      this.drawer.key = key;
      this.drawer.searchFormData = {
        sign_up_id: row.id
      };
      setTimeout(() => {
        this.$refs.drawerTable.setData();
      }, 0);
    },
    async batchSupplyFee() {
      if (!this.total_fee) {
        this.$message.warning('请填写正确的价格！');
        return;
      }
      this.loading = true;
      const temp = { ...this.form };
      Object.keys(this.form).map(key => {
        temp[key] = temp[key] || 0;
        return key;
      });
      const res = await finance.batchSupplyFee({
        params: {
          sign_up_ids: this.selection.map(item => item.id),
          ...temp,
          total_fee: this.total_fee
        }
      });
      if (res) {
        this.$message.success(res.msg || '成功！');
        this.dialogVisible = false;
      }
      this.loading = false;
    },
    openRs(row) {
      this.refundInfo = {
        ...row.refund_user_info,
        pay_type: row.pay_type
      };
      this.refundInfoVisble = true;
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
.pay-search {
  .hd {
    overflow: hidden;
    .fr {
      > .el-input {
        width: 190px;
        margin: 0 20px;
      }
      .el-range-editor {
        vertical-align: bottom;
        .el-range-separator {
          width: 22px;
        }
      }
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .inf-list {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
  .el-button.reservation-number {
    white-space: normal;
    text-align: left;
  }
  .refund-dialog{
    td{
      width:20%;
    }
    .native-table .natable-right{
      text-align: left;
      width:80%;
      max-width:80%;
    }
  }

}
</style>
